import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

/** Without Inci staff holding a VERIFIED SST licencia the selector never renders; this explains why. */
export function NoPsicologosNotice({testId}: {testId: string}) {
  const {t} = useTranslation()
  return (
    <p
      className="rounded-lg border border-dashed border-border px-3 py-2 text-xs text-muted-foreground"
      data-testid={testId}>
      {t('admin.bateria.nuevaDialog.noPsicologos')}{' '}
      <Link to="/admin/licencias" className="font-medium text-primary underline underline-offset-2">
        {t('admin.bateria.nuevaDialog.noPsicologosLink')}
      </Link>
    </p>
  )
}
